export default __webpack_public_path__ + "static/media/climbing-goals.21503bd8.png";